import React from 'react'
import {useField} from 'formik'
import cn from 'classnames'
import DatePicker, {ReactDatePickerProps} from 'react-datepicker'
import {
  formatISO as formatDateISO,
  parseISO as parseDateISO,
} from 'date-fns'
import 'react-datepicker/dist/react-datepicker.css'

export type DatePickerFieldDatePicker = Omit<ReactDatePickerProps, 'onChange' | 'selected'>

export interface DatePickerFieldProps extends React.InputHTMLAttributes<HTMLInputElement>{
  label?: string
  name: string
  datePicker?: DatePickerFieldDatePicker
  inline?: boolean
}

export default function DatePickerField({
  label,
  className,
  datePicker,
  inline,
  ...props
}: DatePickerFieldProps) {
  const [field, meta, {setValue}] = useField(props.name)

  const isInvalid = !!(meta.error && meta.touched)

  function onChange(date: Date | null) {
    setValue(date ? formatDateISO(date, {representation: 'date'}) : '')
  }

  const selected = field.value ? parseDateISO(field.value) : undefined

  return (
    <div className={cn(className)}>
      {label && (
        <label className="form-label">{label}</label>
      )}

      <input type="hidden" {...field} {...props} />

      <DatePicker
        {...datePicker}
        selected={selected}
        onChange={onChange}
        inline={inline}
      />

      {isInvalid && (
        <div className="invalid-feedback">{meta.error}</div>
      )}
    </div>
  )
}
